import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

interface InputProps { 
  id: string, 
  label: string, 
  value: string, 
  type?: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void 
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
}

export default function InputComponent({ 
  id, 
  label, 
  value, 
  onChange, 
  type = 'text', 
  onKeyPress,
  onKeyDown 
}: InputProps) {
  return (
    <Box
      component="form"
      sx={{ '& > :not(style)': { m: 1, width: '25ch' } }}
      noValidate
      autoComplete="off"
    >
      <TextField 
        id={id} 
        className={id}
        label={label} 
        variant="outlined" 
        value={value}
        onChange={onChange}
        type={type}
        onKeyPress={onKeyPress}
        onKeyDown={onKeyDown}
        autoComplete="off"
      />
    </Box>
  );
}